<template>
	<div class="tiplist">
		<div class="top">
			<div class="l_c">
				<div class="title">{{title}}</div>
				<div class="line"></div>
			</div>
			<div class="r_c" @click="$util.goPage('news',sign)">更多 ></div>
		</div>
		<div class="list">
			<div class="signle" v-for="(item,index) in list" :key="index" @click="$util.goPage('newDetail',sign,item.id,sign==21||sign==23?'聚焦青年':'文件资料')">
				<div class="q">
					<div class="circular"></div>
				</div>
				<div class="name" :title="item.title">
					 <!-- {{item.title?item.title:''}} -->
					 {{$util.overfElli(item.title,27)}}
				</div>
				<div class="time">
					{{item.createTime?item.createTime.split(' ')[0].slice(5,):''}}
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>

export default {//5文件资料 11预决算公开 21青年发展规划 23青年说
  props:["title","sign",'list','len'],
  data: function() {
		return {
		  
		  
		};
  },
  
  mounted() {
	
  },

  methods: {
   
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.tiplist{
	.top{
		height: 35px;
		display: flex;
		justify-content: space-between;
		border-bottom: 2px solid #F1F1F1;
		.l_c{
			.title{
				font-size: 18px;
				font-weight: bold;
				color: #BA0711;
			}		
			.line{
			   margin-top: 5px;
				width: 106px;
				height: 5px;
				background: #BA0711;
			}
		}
		.r_c{
			font-size: 14px;
			font-weight: 300;
			color: #BA0711;
			cursor: pointer;
		}
		
	}
	
	
	.list{
		.signle{
			cursor: pointer;
			height: 36px;
			display: flex;
			align-items: center;
			.q{
				width: 10px;
				.circular{
					width: 5px;
					height: 5px;
					border-radius: 50%;
					background-color: #BA0711;
				}
			}
			.name{
				flex: 1;
				text-align: left;
				font-size: 16px;
				font-weight: 400;
				color: #333333;
			}
			.time{
				width: 100px;
				text-align: right;
				font-size: 16px;
				font-weight: 400;
				color: #666666;
			}
		}
		.signle:hover .name{
			color: #BA0711;
		}
		.signle:hover .time{
			color: #BA0711;
		}
	}
	
	
}

</style>
